import React from 'react';
import { Box, Flex, TextV2, ButtonV2 } from '@withjoy/joykit';
import { ReactComponent as ShippingIcon } from '@assets/icons/fast-shipping.svg';
import { useTranslation } from '@shared/core';
import { pxToRem } from '@withjoy/joykit/theme';
import { useAdminRegistryTelemetry } from '@apps/registry/admin/AdminRegistry.telemetry';
import { learnMoreButtonOverrides } from './AddressForm.styles';

export const ShippingControlMessage = () => {
  const { t } = useTranslation('yourRegistry');
  const { shippingControlMessageTitle, shippingControlMessageDescription, learnMore } = t('addressDialog');

  const telemetry = useAdminRegistryTelemetry();

  const handleClick = () => {
    telemetry.clickShippingLearnMore?.();
  };

  return (
    <Box
      padding={6}
      backgroundColor="mono1"
      borderRadius={3}
    >
      <Flex
        flexDirection={['column', 'column', 'row']}
        alignItems={['center', 'center', 'flex-start']}
        columnGap={[0, 5]}
        rowGap={[3, 0]}
      >
        <Box flexShrink={0}>
          <ShippingIcon />
        </Box>
        <Flex
          flexDirection="column"
          alignItems={['center', 'center', 'flex-start']}
          textAlign={['center', 'center', 'left']}
        >
          <TextV2
            typographyVariant="hed4"
            color="mono14"
          >
            {shippingControlMessageTitle()}
          </TextV2>
          <TextV2
            marginTop={pxToRem(10)}
            typographyVariant="body1"
            color="mono12"
          >
            {shippingControlMessageDescription()}{' '}
            <ButtonV2
              textDecoration="underline"
              target="_blank"
              as="a"
              href="/shipping-policy"
              variant="ghost"
              overrides={learnMoreButtonOverrides}
              onClick={handleClick}
              style={{ textDecorationColor: '#595959' }}
            >
              {learnMore()}
            </ButtonV2>
          </TextV2>
        </Flex>
      </Flex>
    </Box>
  );
};
